import { AttributeFilterItemProps } from "../../../common/interfaces";
import React, { useContext } from "react";
import { Slider } from "@glamcorner/components/lib/core/components/Slider";
import { FilterContext } from "../../FilterContext";

export const AttributeFilterItemSlider: React.FC<AttributeFilterItemProps> = ({ attributeFilter }) => {
  const { applyAttributeFilter, appliedAttributeFilters } = useContext(FilterContext);
  const appliedAttributeFilter = appliedAttributeFilters.find(filter => filter.code === attributeFilter.code);
  let initialValues: [number, number] = [0, 400];
  if (appliedAttributeFilter && appliedAttributeFilter.options && appliedAttributeFilter.options.length) {
    const [min, max] = appliedAttributeFilter.options[0].value.split(",");
    initialValues = [Number(min), Number(max)];
  }

  return (
    <Slider
      prefix="$"
      initialValues={initialValues}
      min={0}
      max={400}
      step={10}
      onChange={([min, max]) =>
        applyAttributeFilter({
          ...attributeFilter,
          options: [
            {
              label: `$${min} - $${max}`,
              value: `${min},${max}`
            }
          ]
        })
      }
    />
  );
};
